<template>
  <footer class="bg-dark text-white pt-4 pb-2 mt-auto">
    <div class="container">
      <div class="row">
        <!-- 區塊：網站導覽 -->
        <div class="col-md-4 mb-3">
          <h5>{{ $t('nav.webNav') }}</h5>
          <ul class="list-unstyled">
            <li><router-link to="/" class="text-white text-decoration-none">{{ $t('nav.home') }}</router-link></li>
            <li><router-link to="/about" class="text-white text-decoration-none">{{ $t('nav.about') }}</router-link></li>
            <li><router-link to="/introduce" class="text-white text-decoration-none">{{ $t('nav.products') }}</router-link></li>
            <li><router-link to="/contact" class="text-white text-decoration-none">{{ $t('nav.contact') }}</router-link></li>
          </ul>
        </div>

        <!-- 區塊：服務條款 -->
        <!-- <div class="col-md-4 mb-3">
          <h5>政策與條款</h5>
          <ul class="list-unstyled">
            <li><a href="#" class="text-white text-decoration-none">隱私權政策</a></li>
            <li><a href="#" class="text-white text-decoration-none">使用條款</a></li>
            <li><a href="#" class="text-white text-decoration-none">退換貨政策</a></li>
          </ul>
        </div> -->

        <!-- 區塊：聯絡資訊 -->
        <div class="col-md-4 mb-3">
          <h5>{{ $t('contact.title')}}</h5>
          <p class="mb-1">{{ $t('footer.serviceEmail')}}：service@inritek.com.tw</p>
          <p class="mb-1">{{ $t('footer.phone')}}：+886-967-178-233</p>
          <p class="mb-0">{{ $t('footer.address')}}：{{ $t('footer.address_content')}}</p>
        </div>
      </div>

      <hr class="bg-white" />
      <div class="text-center small">
        &copy; 2025 Inritek Website. All rights reserved.
      </div>
    </div>
  </footer>
</template>

<script setup>
// 無特殊邏輯，目前為靜態 Footer
</script>

<style scoped>
footer {
  font-size: 0.95rem;
}
</style>